import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100">
          <i className="ri-file-unknow-line text-3xl text-foreground-300"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-4">This page has not been generated</h2>
        <p className="mt-2 text-sm md:text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-foreground-600">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-sm font-label font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
        >
          <i className="ri-home-4-line"></i>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}